import { DiseaseChoicesTranslations } from './types';

export const deChoiceTranslations: DiseaseChoicesTranslations = {
    title: "Krankheiten auswählen",
    selectAll: "Alle auswählen",
    noDiseasesSelected: "Keine Krankheiten ausgewählt"
};